import {
  loomRegex,
  youtubeRegex,
} from 'components/CreateSpark/SparkBuilderDrawers/SparkBuilderSettingsFiles/ImagesAndMedia/VideoLoom';

// Helper function to validate YouTube and Loom URLs
const isValidVideoUrl = (url: string): boolean =>
  youtubeRegex.test(url) || loomRegex.test(url);

// Helper function to get file extension from MIME type
const getExtensionFromMimeType = (mimeType: string): string => {
  const mimeToExt: { [key: string]: string } = {
    'audio/mp3': 'mp3',
    'audio/mpeg': 'mp3',
    'audio/wav': 'wav',
    'audio/wave': 'wav',
    'audio/x-wav': 'wav',
    'audio/m4a': 'm4a',
    'audio/mp4': 'm4a',
    'audio/aac': 'aac',
    'audio/ogg': 'ogg',
    'audio/webm': 'webm',
    'audio/flac': 'flac',
    'audio/x-flac': 'flac',
  };
  return mimeToExt[mimeType.toLowerCase()] || '';
};

// Helper function to validate audio URLs based on accepted MIME types
const isValidAudioUrl = (url: string, acceptedMimeTypes: string[]): boolean => {
  if (!acceptedMimeTypes || acceptedMimeTypes.length === 0) return true;

  const allowedExtensions = acceptedMimeTypes
    .map((mimeType) => getExtensionFromMimeType(mimeType))
    .filter((ext) => ext !== '');

  if (allowedExtensions.length === 0) return true;

  // Check if URL ends with any of the allowed extensions
  const urlLower = url.toLowerCase();
  return allowedExtensions.some(
    (ext) =>
      urlLower.endsWith(`.${ext}`) ||
      urlLower.includes(`.${ext}?`) ||
      urlLower.includes(`.${ext}#`)
  );
};

const readFileAsBase64 = (file: File): Promise<string> => {
  return new Promise<string>((resolve, reject) => {
    const reader = new FileReader();

    reader.onload = (event: ProgressEvent<FileReader>) => {
      const result = event.target?.result as string;
      if (result) {
        // Remove the data URL prefix to get just the base64 content
        const base64Content = result.split(',')[1];
        resolve(base64Content);
      } else {
        reject(new Error('Failed to read file'));
      }
    };

    reader.onerror = (error: ProgressEvent<FileReader>) => {
      console.log('Error reading file', error);
      reject(new Error('Error reading file'));
    };

    // Read all files as data URL, then extract base64 content
    reader.readAsDataURL(file);
  });
};

export { isValidAudioUrl, isValidVideoUrl, readFileAsBase64 };
